import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { id: "header" }
const _hoisted_2 = { class: "navbar navbar-expand-lg navbar-dark bg-primary" }
const _hoisted_3 = {
  key: 0,
  class: "badge badge-pill badge-secondary env dev"
}
const _hoisted_4 = {
  key: 1,
  class: "badge badge-pill badge-secondary env stg"
}
const _hoisted_5 = { class: "form-inline my-2 my-lg-0 nav-right-side" }
const _hoisted_6 = { class: "user-display-name" }

import {
  computed,
  useTemplateRef,
} from 'vue';
import { useRoute } from 'vue-router';
import { useAuth } from 'src/composables/useAuth';
import { useEnv } from 'src/composables/useEnv';
import { clearSession } from 'src/services/session';


export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalHeader',
  setup(__props) {

const auth = useAuth();
const { isDevelopment, isStaging } = useEnv();
const route = useRoute();
const refNavbarCollapse = useTemplateRef<HTMLElement>('refNavbarCollapse');

const displayName = computed<string>(() => auth.user?.displayName ?? '');
const isAdmin = computed<boolean>(() => {
  // 管理画面へのアクセス権限：部署管理者も含む
  return auth.user?.hasRoleDepartmentAdmin ?? false;
});
const hasRoleSuperAdmin = computed<boolean>(() => auth.user?.hasRoleSuperAdmin ?? false);
const isLoggedIn = computed<boolean>(() => auth.user !== null);
const isPageTop = computed<boolean>(() => String(route.name ?? '').indexOf('Top') === 0);
const isAdminPageGroup = computed<boolean>(() => String(route.name ?? '').indexOf('Admin') === 0);
const isDevDebugPageGroup = computed<boolean>(() => String(route.name ?? '').indexOf('DevDebug') === 0);


const onNavVarClick = (evt: Event) => {
  // 押されたら閉じる
  const target = evt.target as HTMLElement;
  if (target.classList.contains('nav-link')) {
    if (refNavbarCollapse.value) {
      $(refNavbarCollapse.value).collapse('hide');
    }
  }
};
const logout = async() => {
  // logout API が失敗してもローカルのセッションは破棄してログイン画面へ戻す
  let redirectUrl = '';
  try {
    const response = await auth.logout();
    redirectUrl = response.redirectUrl ?? '';
  } finally {
    clearSession();
    location.href = redirectUrl || '/login';
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: {name: 'Top'},
        class: "navbar-brand"
      }, {
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createTextVNode(" 動画共有 ", -1)),
          (_unref(isDevelopment))
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "dev"))
            : _createCommentVNode("", true),
          (_unref(isStaging))
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "stg"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _cache[5] || (_cache[5] = _createElementVNode("button", {
        class: "navbar-toggler",
        type: "button",
        "data-toggle": "collapse",
        "data-target": "#navbar-nav-items",
        "aria-controls": "navbar-nav-items",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation"
      }, [
        _createElementVNode("span", { class: "navbar-toggler-icon" })
      ], -1)),
      _createElementVNode("div", {
        id: "navbar-nav-items",
        class: "collapse navbar-collapse",
        ref_key: "refNavbarCollapse",
        ref: refNavbarCollapse
      }, [
        _createElementVNode("ul", {
          class: "navbar-nav mr-auto",
          onClick: onNavVarClick
        }, [
          _createElementVNode("li", {
            class: _normalizeClass(["nav-item", {active: isPageTop.value}])
          }, [
            _createVNode(_component_router_link, {
              to: {name: 'Top'},
              class: "nav-link"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" 地図 ", -1)
              ]))]),
              _: 1
            })
          ], 2),
          (isAdmin.value)
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                class: _normalizeClass(["nav-item", {active: isAdminPageGroup.value}])
              }, [
                _createVNode(_component_router_link, {
                  to: {name:'AdminTop'},
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" 管理画面 ", -1)
                  ]))]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          (hasRoleSuperAdmin.value)
            ? (_openBlock(), _createElementBlock("li", {
                key: 1,
                class: _normalizeClass(["nav-item", {active: isDevDebugPageGroup.value}])
              }, [
                _createVNode(_component_router_link, {
                  to: {name:'DevDebugTop'},
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode(" 開発者用画面 ", -1)
                  ]))]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, " ユーザー名: " + _toDisplayString(displayName.value), 1),
          _createElementVNode("a", {
            href: "#",
            onClick: _withModifiers(logout, ["prevent"]),
            class: "logout ml12"
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "fas fa-sign-out-alt" }, null, -1),
            _createElementVNode("span", null, "ログアウト", -1)
          ]))])
        ], 512), [
          [_vShow, isLoggedIn.value]
        ])
      ], 512)
    ])
  ]))
}
}

})